import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'no_appointed_doctor_nurse_medical_facilities_clinic_s'

export const dataPointDefinition = {
  retracedId: 'no_appointed_doctor_nurse_medical_facilities_clinic_s',
  name: 'No appointed doctor/nurse for medical facilities/clinic(s)',
  description: '',
  meta: {
    slcpMeta: {
      key: 'hs-fir-36x',
      number: 'HS-FIR-6-4',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-fir-32',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-fir-30,Yes;No;No applicable legal requirements',
      machineShowHide: '[2],hs-fir-30,1;2;4',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-fir-36x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31080,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
